import React, { useState, useEffect } from "react";
import { useQueries } from 'react-query'
import { useQueryClient } from "react-query";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { useViewport } from 'components/general/useViewPort'
import Label from "components/general/Label"
import Loader from 'components/general/Loader'
import PageHeader from "components/common/PageHeader";
import NotAvailable from "components/common/NotAvailable";
import { SimpleProgressBar } from "components/general/ProgressBar";
import GarApparatus from "components/sports/gar/views/GarApparatus";
import GarRotations from "components/sports/gar/views/GarRotations";
import GarTeams from "components/sports/gar/views/GarTeams";
import GarTeamsLeaders from "components/sports/gar/views/GarTeamsLeaders";
import { APPARATUS, EVENT, isQualification, isTeam, isIndAllAround, isIndFinalApparatus } from "components/sports/gar/helper/GarHelpers";
import { getUnits, getEvents, getScheduleData } from "data/Querys"
import { scheduleIsHigherRunning, scheduleIsHigherGettingReady } from "helpers/status";
import { getPhaseRSC, getRscObject } from 'helpers/rsc'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


const GarContext = () => {
    const { mirs_competition, mirs_rsc, mirs_language, mirs_discipline } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport();
    const [key, setKey] = useState('results');
    const rscObj = getRscObject(mirs_rsc)
    let apparatus = (rscObj.sex === "M") ? APPARATUS.MEN : APPARATUS.WOMEN;
    const isMobile = (breakPoint === "sm" || breakPoint === "xs")

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])


    //DATA

    let _phase = getPhaseRSC(mirs_rsc);
    let queryArray = []

    //DATA
    /*
    const { data: unitsData, isError: unitsError, isLoading: unitsLoading } = useQuery(
        {
            queryKey: ['unitsPhase', mirs_competition, mirs_language, _phase],
            queryFn: getUnits,
            //refetchInterval: 30000,
            staleTime: Infinity,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        }
    );
*/
    queryArray.push({
        queryKey: ['unitsPhase', mirs_competition, mirs_language, _phase],
        queryFn: getUnits,
        refetchInterval: 0,
        staleTime: Infinity,
        refetchIntervalInBackground: true,
        notifyOnChangeProps: ['data', 'error'],
    })

    if (isIndFinalApparatus(mirs_rsc)) {
        //load events only in final apparatus in order to write event name in headers 
        queryArray.push({
            queryKey: ['events', mirs_competition, mirs_language, mirs_discipline],
            queryFn: getEvents,
            refetchInterval: 0,
            staleTime: Infinity,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        })
    }

    /// recoger estado de la unit del calendario ver como 


    queryArray.push({
        queryKey: ['scheduleData', mirs_competition, mirs_language, mirs_discipline],
        queryFn: getScheduleData,
        refetchInterval: 30000,
        refetchIntervalInBackground: true,
        cacheTime: 300000,
        staleTime: 20000,
        suspense: false,
        notifyOnChangeProps: ['data', 'error']
    })


    let query = ['scheduleData', mirs_competition, mirs_language, mirs_discipline]
    const queryClient = useQueryClient();
    const dataSchedule = queryClient.getQueryData(query);


    const _isTeam = isTeam(mirs_rsc);
    const _isIndAllAround = isIndAllAround(mirs_rsc);
    const _isQualification = isQualification(_phase);
    const _isIndFinalApparatus = isIndFinalApparatus(mirs_rsc);
    let event = ""
    if (_isTeam) {
        event = EVENT.TEAM
    } else if (_isIndAllAround) {
        event = EVENT.ALL_AROUND
    }

    const results = useQueries(queryArray);
    const isLoading = results.some(result => result.isLoading)
    const isError = results.some(result => result.isError)

    if (isError) { return <NotAvailable />; }
    if (isLoading) { return <Loader />; }

    const unitsData = results[0].data
    const eventsData = results.length > 1 && results[1].data
    const resultStatus = dataSchedule.find(evUnit => evUnit?.eventUnit?.code === mirs_rsc)?.status?.code;




    //const resultStatus = "LIVE"
    const intermediates = []
    Array.isArray(unitsData?.phase?.units) && unitsData?.phase?.units.forEach((unit, index) => {
        intermediates.push(
            {
                "code": unit.code,
                "value": unit.shortDescription,
                "pos": index,
            }
        )
    })

    const current = intermediates.find(item => item.code === mirs_rsc)
    const progressBarData = {
        "currentPosition": current?.pos,
        "finalPosition": 2,
        "intermediates": intermediates
    }
    const numElements = intermediates.length;
    let dataHeader = unitsData?.phase?.units.find(item => item.code === mirs_rsc)?.description

    if (_isIndFinalApparatus) {
        dataHeader = Array.isArray(eventsData?.events) && eventsData?.events.find(item => item.code === "GAR" + rscObj.sex + "1AP---------------")?.description
    }

    return (
        <>
            {

                <>
                    <PageHeader title={dataHeader} />
                    <div className='mirs-page-container'>
                    {progressBarData && _isQualification && !isMobile && <SimpleProgressBar id={`mirs-progressbar-${mirs_rsc}`} data={progressBarData} numElements={numElements} />}
                    {(_isTeam || _isIndAllAround) && scheduleIsHigherGettingReady(resultStatus) && !scheduleIsHigherRunning(resultStatus) && <GarTeamsLeaders event={event} />}

                    {!_isIndFinalApparatus && <Tabs
                        id="mirs-navsport"
                        className="mb-3 mirs-tab-result"
                        defaultActiveKey={`1-${mirs_rsc}`}
                        onSelect={(k) => setKey(k)}
                        mountOnEnter={true}
                        unmountOnExit={true}
                    >
                        {!_isIndFinalApparatus && <Tab eventKey={`1-${mirs_rsc}`} title={<Label data="HeaderRotations" />} >
                            <GarRotations apparatus={apparatus} />
                        </Tab>}

                        {(_isQualification || _isTeam) && <Tab eventKey={`2-${mirs_rsc}`} title={<Label data="TeamResults" />} disabled={!scheduleIsHigherGettingReady(resultStatus)}
                        >
                            <GarTeams event={EVENT.TEAM} />
                        </Tab>}

                        {(_isQualification || _isIndAllAround) && <Tab eventKey={`3-${mirs_rsc}`} title={<Label data="AllAroundResults" />} disabled={!scheduleIsHigherGettingReady(resultStatus)}
                        >
                            <GarTeams event={EVENT.ALL_AROUND} />
                        </Tab>}

                        {_isQualification && <Tab eventKey={`4-${mirs_rsc}`} title={<Label data="HeaderApparatus" />} disabled={!scheduleIsHigherGettingReady(resultStatus)}
                        >
                            <GarApparatus apparatus={apparatus} />
                        </Tab>}

                    </Tabs>}
                    {_isIndFinalApparatus &&
                        <GarApparatus apparatus={apparatus} />
                    }
                    </div>


                </>

            }
        </>
    );
};

export default GarContext;
